export enum AuthTypeValue {
  TOTP = 'TOTP',
  EMAIL = 'EMAIL',
  DEFAULT = 'DEFAULT',
}
